import React, { useState, useEffect } from "react";
import LogoPoliSenzaScritta from "../images/logo_est_polito_EC_noBackgroud.png";
import axios from "axios";
import { WAVE_USERS_URL } from "../actions/types";
import SuccessAlert from "../components/Modals/SuccessAlert";
import ErrorAlert from "../components/Modals/ErrorAlert";
import { Spinner } from "reactstrap";
import InfoAlert from "../components/Modals/InfoAlert";

export default function ResetPassword(props) {
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [loading, setLoading] = useState(false);

  const queryParams = props.location.search.replace("?", "");
  const [key, value] = queryParams.split("=");

  const onSubmit = (e) => {
    e.preventDefault();
    if (password.length < 8) {
      InfoAlert("The length of the password cannot be less than 8 characters");
    } else {
      if (loading === false) {
        setLoading(true);
        axios
          .post(WAVE_USERS_URL + `reset_password/?token=${value}`, {
            password,
            password_confirmation: passwordConfirmation,
          })
          .then((res) => {
            setPassword("");
            setPasswordConfirmation("");
            SuccessAlert("Password resetted");
            props.history.push("/");
            setLoading(false);
          })
          .catch((error) => {
            ErrorAlert(error.response.data.detail);
            setLoading(false);
          });
      }
    }
  };

  if (
    key === "token" &&
    value !== "" &&
    value !== undefined &&
    value !== null
  ) {
    return (
      <div className="mainLogin">
        <div className="container" id="container">
          <div className="form-container sign-in-container">
            <form onSubmit={onSubmit}>
              <h4 style={{ marginBottom: 14 }}>
                Reset <br />
                your credentials
              </h4>
              <input
                type="password"
                placeholder="New password"
                className="inputForm"
                onChange={(e) => setPassword(e.target.value)}
              />
              <input
                type="password"
                placeholder="Confirm your new password"
                className="inputForm"
                onChange={(e) => setPasswordConfirmation(e.target.value)}
              />
              {loading === true ? (
                <button style={{ marginTop: 14 }}>
                  <Spinner size="sm"> </Spinner>
                </button>
              ) : (
                <button style={{ marginTop: 14 }}>Reset</button>
              )}
            </form>
          </div>
          <div className="overlay-container">
            <div className="overlay">
              <div className="overlay-panel overlay-right">
                {/* <h1 style={{ marginBottom: 30 }}>Welcome</h1> */}
                <img
                  src={LogoPoliSenzaScritta}
                  style={{ width: "280px", height: "auto" }}
                ></img>
                <h3 style={{ marginBottom: 30 }}>… PLAT.form of energy</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="mainLogin">
        <div className="container" id="container">
          <div className="form-container sign-in-container">
            <form onSubmit={onSubmit}>
              <h3 style={{ marginBottom: 14 }}>Invalid link</h3>
            </form>
          </div>
          <div className="overlay-container">
            <div className="overlay">
              <div className="overlay-panel overlay-right">
                {/* <h1 style={{ marginBottom: 30 }}>Welcome</h1> */}
                <img
                  src={LogoPoliSenzaScritta}
                  style={{ width: "280px", height: "auto" }}
                ></img>
                <h3 style={{ marginBottom: 30 }}>… PLAT.form of energy</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
